export enum StatusExecucao {
  show = 'Show',
  noShow = 'No Show',
  semAgenda = 'Sem Agenda',
  foraDeHora = 'Fora de Hora'
}
